/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ManagedServiceStatus = {
  Starting: "starting",
  Ready: "ready",
  Unhealthy: "unhealthy",
  Stopped: "stopped",
} as const;
export type ManagedServiceStatus = ClosedEnum<typeof ManagedServiceStatus>;

/** @internal */
export const ManagedServiceStatus$inboundSchema: z.ZodNativeEnum<
  typeof ManagedServiceStatus
> = z.nativeEnum(ManagedServiceStatus);
/** @internal */
export const ManagedServiceStatus$outboundSchema: z.ZodNativeEnum<
  typeof ManagedServiceStatus
> = ManagedServiceStatus$inboundSchema;
